import { isObject, reduce } from 'lodash';

// converts Javascript names for style props to the css names e.g. lineHeight to line-height
var convertStyleKey = function convertStyleKey(string) {
  return string.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
};

// TODO make more comprehensive list;
var nonPixelProps = ['opacity', 'lineHeight', 'fontWeight'];

// The aim here is to convert js values to CSS versions. E.g. change 24 to 24px for widths
export var convertStyleValue = function convertStyleValue(value, key) {
  if (Number.isInteger(value) && !nonPixelProps.includes(key)) {
    return "".concat(value, "px");
  }
  return value;
};

// Take a javascript style object key and value and convert to a CSS string.
// Used in reduce functions with the `css` argument being the carried string.
var _reduceStyleObjectToCss = function reduceStyleObjectToCss(css, value, key) {
  var propCss = '';
  if (isObject(value)) {
    propCss = "".concat(key, " {\n     ").concat(reduce(value, _reduceStyleObjectToCss, ''), "\n    }");
  } else {
    propCss = "".concat(convertStyleKey(key), ": ").concat(convertStyleValue(value, key), ";");
  }
  return "".concat(css, "\n  ").concat(propCss);
};
export { _reduceStyleObjectToCss as reduceStyleObjectToCss };